import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { LimpiezaDatos } from '../components/LimpiezaDatos';

const TIPOS = [
  {
    key: 'pesajes', label: 'Pesajes', desc: 'Pesos, altura cadera, observaciones',
    endpoint: '/importar-campo/pesajes', plantilla: '/importar-campo/plantilla/pesajes',
    color: 'bg-green-100 text-green-800 border-green-300',
    icon: 'M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3',
  },
  {
    key: 'servicios', label: 'Servicios', desc: 'Monta natural, inseminacion, resultados',
    endpoint: '/importar-campo/servicios', plantilla: '/importar-campo/plantilla/servicios',
    color: 'bg-blue-100 text-blue-800 border-blue-300',
    icon: 'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z',
  },
  {
    key: 'pariciones', label: 'Pariciones', desc: 'Partos, terneros, pesos nacimiento',
    endpoint: '/importar-campo/pariciones', plantilla: '/importar-campo/plantilla/pariciones',
    color: 'bg-pink-100 text-pink-800 border-pink-300',
    icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z',
  },
  {
    key: 'controles', label: 'Control Machos', desc: 'CE, motilidad, aptitud andrologica',
    endpoint: '/importar-campo/controles-machos', plantilla: '/importar-campo/plantilla/controles-machos',
    color: 'bg-amber-100 text-amber-800 border-amber-300',
    icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
  },
  {
    key: 'destete', label: 'Destete', desc: 'Peso destete, madre, EP automatico',
    endpoint: '/importar-campo/destete', plantilla: '/importar-campo/plantilla/destete',
    color: 'bg-emerald-100 text-emerald-800 border-emerald-300',
    icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z',
  },
  {
    key: 'vacunacion', label: 'Vacunacion', desc: 'Vacunas y antiparasitarios',
    endpoint: '/importar-campo/sanitarios', plantilla: '/importar-campo/plantilla/vacunacion',
    color: 'bg-teal-100 text-teal-800 border-teal-300',
    icon: 'M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z',
  },
  {
    key: 'enfermedad', label: 'Enfermedad', desc: 'Diagnostico y tratamiento',
    endpoint: '/importar-campo/sanitarios', plantilla: '/importar-campo/plantilla/enfermedad',
    color: 'bg-orange-100 text-orange-800 border-orange-300',
    icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
  },
  {
    key: 'medicamento', label: 'Medicamento', desc: 'Aplicacion de medicamentos',
    endpoint: '/importar-campo/sanitarios', plantilla: '/importar-campo/plantilla/medicamento',
    color: 'bg-cyan-100 text-cyan-800 border-cyan-300',
    icon: 'M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z',
  },
  {
    key: 'mortandad', label: 'Mortandad', desc: 'Registro de bajas',
    endpoint: '/importar-campo/sanitarios', plantilla: '/importar-campo/plantilla/mortandad',
    color: 'bg-red-100 text-red-800 border-red-300',
    icon: 'M6 18L18 6M6 6l12 12',
  },
  {
    key: 'lesion', label: 'Lesion', desc: 'Lesiones y heridas',
    endpoint: '/importar-campo/sanitarios', plantilla: '/importar-campo/plantilla/lesion',
    color: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z',
  },
  {
    key: 'genealogia', label: 'Madre y Padre', desc: 'Asignar madre y padre a terneros ya cargados',
    endpoint: '/importar-campo/genealogia', plantilla: '/importar-campo/plantilla/genealogia',
    color: 'bg-indigo-100 text-indigo-800 border-indigo-300',
    icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
  },
  {
    key: 'observacion', label: 'Observacion', desc: 'Observaciones generales',
    endpoint: '/importar-campo/sanitarios', plantilla: '/importar-campo/plantilla/observacion',
    color: 'bg-purple-100 text-purple-800 border-purple-300',
    icon: 'M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z',
  },
];

const ImportarCampoPage = () => {
  const { user } = useAuth();
  const [selectedTipo, setSelectedTipo] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleDescargarPlantilla = async (tipo) => {
    try {
      const res = await api.get(tipo.plantilla, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      const filename = `TKorveX_Plantilla_${tipo.label.replace(/\s/g, '')}.xlsx`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      setError('Error al descargar plantilla');
    }
  };

  const [crearMadres, setCrearMadres] = useState(false);

  const handleImportar = async () => {
    if (!file || !selectedTipo) return;
    setLoading(true);
    setError('');
    setResult(null);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('establecimiento_id', user.establecimiento_id);
    if (selectedTipo.key === 'genealogia') formData.append('crear_madres', crearMadres ? 'true' : 'false');

    try {
      const res = await api.post(selectedTipo.endpoint, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setResult(res.data);
      setFile(null);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al importar archivo');
    } finally {
      setLoading(false);
    }
  };

  // Balanza import
  const [balanzaFile, setBalanzaFile] = useState(null);
  const [balanzaNombre, setBalanzaNombre] = useState('');
  const [balanzaLoading, setBalanzaLoading] = useState(false);
  const [balanzaResult, setBalanzaResult] = useState(null);

  const handleImportarBalanza = async () => {
    if (!balanzaFile) return;
    setBalanzaLoading(true);
    setError('');
    setBalanzaResult(null);
    const formData = new FormData();
    formData.append('file', balanzaFile);
    formData.append('establecimiento_id', user.establecimiento_id);
    formData.append('nombre_sesion', balanzaNombre || '');
    formData.append('tipo_sesion', 'pesaje');
    try {
      const res = await api.post('/importar-campo/balanza', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setBalanzaResult(res.data);
      setBalanzaFile(null);
      setBalanzaNombre('');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al importar archivo de balanza');
    } finally {
      setBalanzaLoading(false);
    }
  };

  return (
    <div className="p-4 sm:p-6 space-y-6" data-testid="importar-campo-page">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900">Importar Registros de Campo</h1>
        <p className="text-sm text-gray-500 mt-1">Descarga la plantilla Excel, completala en el campo y subila para generar los registros automaticamente</p>
      </div>

      {error && <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm" data-testid="import-error">{error}</div>}

      {/* IMPORTAR SESION DE BALANZA */}
      <div className="bg-gray-900 rounded-2xl p-6 text-white" data-testid="balanza-section">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
            </svg>
          </div>
          <div>
            <h2 className="text-lg font-bold">Importar Sesion de Balanza</h2>
            <p className="text-xs text-gray-400">XRS2i, Tru-Test, XR5000 — Subi el archivo directo del dispositivo (.xls, .xlsx, .csv)</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
          <div>
            <label className="block text-xs text-gray-400 mb-1">Nombre de la sesion (opcional)</label>
            <input type="text" value={balanzaNombre} onChange={e => setBalanzaNombre(e.target.value)}
              placeholder="Ej: Pesaje Lote Norte Mayo"
              className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm placeholder-gray-500 focus:ring-2 focus:ring-green-500"
              data-testid="balanza-nombre" />
          </div>
          <div>
            <label className="block text-xs text-gray-400 mb-1">Archivo del dispositivo</label>
            <label className="flex items-center justify-center px-3 py-2 bg-gray-800 border border-dashed border-gray-600 rounded-lg cursor-pointer hover:border-green-500 transition">
              <input type="file" accept=".xls,.xlsx,.csv" className="hidden" onChange={e => setBalanzaFile(e.target.files?.[0] || null)} data-testid="balanza-file" />
              <span className="text-sm">{balanzaFile ? <span className="text-green-400 font-medium">{balanzaFile.name}</span> : <span className="text-gray-500">Seleccionar archivo...</span>}</span>
            </label>
          </div>
          <div className="flex items-end">
            <button onClick={handleImportarBalanza} disabled={!balanzaFile || balanzaLoading}
              className="w-full px-4 py-2 bg-green-600 text-white rounded-lg font-medium hover:bg-green-500 disabled:opacity-40 transition text-sm"
              data-testid="balanza-import-btn">
              {balanzaLoading ? 'Importando...' : 'Importar Sesion'}
            </button>
          </div>
        </div>

        {balanzaResult && (
          <div className="bg-gray-800 rounded-lg p-4 space-y-2">
            <p className="text-green-400 font-semibold text-sm">{balanzaResult.message}</p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-center">
              <div><p className="text-2xl font-bold text-white">{balanzaResult.total_registros}</p><p className="text-xs text-gray-400">Total registros</p></div>
              <div><p className="text-2xl font-bold text-green-400">{balanzaResult.pesajes_creados}</p><p className="text-xs text-gray-400">Pesajes creados</p></div>
              <div><p className="text-2xl font-bold text-amber-400">{balanzaResult.animales_nuevos}</p><p className="text-xs text-gray-400">Animales nuevos</p></div>
              <div><p className="text-2xl font-bold text-blue-400">{balanzaResult.animales_existentes}</p><p className="text-xs text-gray-400">Existentes</p></div>
            </div>
            {balanzaResult.errors_count > 0 && (
              <div className="mt-2">
                <p className="text-xs text-red-400 font-medium">{balanzaResult.errors_count} errores:</p>
                <ul className="text-xs text-red-300 mt-1 max-h-20 overflow-y-auto">
                  {balanzaResult.errors?.slice(0, 10).map((e, i) => <li key={i}>{e}</li>)}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Separador */}
      <div className="flex items-center gap-4">
        <div className="flex-1 border-t border-gray-200" />
        <span className="text-xs text-gray-400 font-medium">O usa plantillas manuales</span>
        <div className="flex-1 border-t border-gray-200" />
      </div>

      {/* Tipo selector */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {TIPOS.map(tipo => (
          <div
            key={tipo.key}
            onClick={() => { setSelectedTipo(tipo); setResult(null); setFile(null); setError(''); }}
            className={`p-4 rounded-xl border-2 cursor-pointer transition-all hover:shadow-md ${
              selectedTipo?.key === tipo.key ? 'border-green-500 bg-green-50 shadow-md' : 'border-gray-200 bg-white hover:border-gray-300'
            }`}
            data-testid={`tipo-${tipo.key}`}
          >
            <div className="flex items-center gap-3 mb-2">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${tipo.color}`}>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={tipo.icon} />
                </svg>
              </div>
              <h3 className="font-bold text-gray-900">{tipo.label}</h3>
            </div>
            <p className="text-xs text-gray-500">{tipo.desc}</p>
          </div>
        ))}
      </div>

      {/* Action panel */}
      {selectedTipo && (
        <div className="bg-white rounded-xl shadow-sm p-6 space-y-5" data-testid="import-panel">
          <div className="flex items-center justify-between flex-wrap gap-3">
            <h2 className="text-lg font-bold text-gray-900">
              Importar {selectedTipo.label}
            </h2>
            <button
              onClick={() => handleDescargarPlantilla(selectedTipo)}
              className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm font-medium transition"
              data-testid="descargar-plantilla-btn"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Descargar Plantilla Excel
            </button>
          </div>

          {/* Steps guide */}
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="text-sm font-semibold text-gray-700 mb-2">Pasos:</p>
            <ol className="text-sm text-gray-600 space-y-1 list-decimal ml-4">
              <li>Descarga la plantilla Excel con el boton verde</li>
              <li>Completa los datos en el campo (los VID deben coincidir con animales existentes)</li>
              <li>Subi el archivo completado abajo</li>
              <li>El sistema validara los datos y creara los registros automaticamente</li>
            </ol>
          </div>

          {/* File upload */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Subir archivo completado</label>
            {selectedTipo.key === 'genealogia' && (
              <div className="mb-3 p-3 bg-indigo-50 border border-indigo-200 rounded-lg text-sm text-indigo-900" data-testid="genealogia-opciones">
                <p className="mb-2">Columnas: <b>Ternero VID</b> o <b>Ternero IDE</b> (o simplemente <b>VID</b>), <b>Madre VID</b>, <b>Padre VID</b>. En Padre: caravana del toro propio, codigo de semen (ej. IA BO414), <b>MONTA</b> (se busca el toro en los servicios de la madre) o vacio (se deduce del servicio).</p>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={crearMadres} onChange={e => setCrearMadres(e.target.checked)} data-testid="crear-madres-check" />
                  <span>Crear como vaca las madres que no esten registradas (en vez de informarlas como error)</span>
                </label>
              </div>
            )}
            <div className="flex items-center gap-3">
              <label className="flex-1 flex items-center justify-center px-4 py-4 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-green-400 hover:bg-green-50 transition" data-testid="file-upload-area">
                <input
                  type="file"
                  accept=".xlsx,.xls,.csv"
                  className="hidden"
                  onChange={e => setFile(e.target.files?.[0] || null)}
                  data-testid="file-input"
                />
                <div className="text-center">
                  {file ? (
                    <p className="text-sm font-medium text-green-700">{file.name}</p>
                  ) : (
                    <p className="text-sm text-gray-500">Click para seleccionar archivo (.xlsx, .xls, .csv)</p>
                  )}
                </div>
              </label>
              <button
                onClick={handleImportar}
                disabled={!file || loading}
                className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 font-semibold text-sm transition whitespace-nowrap"
                data-testid="importar-btn"
              >
                {loading ? 'Importando...' : 'Importar'}
              </button>
            </div>
          </div>

          {/* Results */}
          {result && (
            <div className="border rounded-lg overflow-hidden" data-testid="import-result">
              <div className={`p-4 ${result.errors_count > 0 ? 'bg-amber-50 border-b border-amber-200' : 'bg-green-50 border-b border-green-200'}`}>
                <p className={`text-sm font-bold ${result.errors_count > 0 ? 'text-amber-800' : 'text-green-800'}`}>
                  {result.message}
                </p>
                <div className="flex gap-4 mt-2 text-xs">
                  <span className="text-green-700 font-medium">Importados: {result.imported}</span>
                  {result.errors_count > 0 && (
                    <span className="text-red-700 font-medium">Errores: {result.errors_count}</span>
                  )}
                </div>
              </div>
              {result.errors?.length > 0 && (
                <div className="p-4 bg-white max-h-48 overflow-y-auto">
                  <p className="text-xs font-semibold text-gray-700 mb-2">Detalle de errores:</p>
                  {result.errors.map((err, i) => (
                    <p key={i} className="text-xs text-red-600 py-0.5">{err}</p>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <LimpiezaDatos />
    </div>
  );
};

export default ImportarCampoPage;
